// extracted by mini-css-extract-plugin
export default {"loader":"_2ZjHv","load6":"_2coRL","medium":"_1Meu2","mini":"_3_fII"};